export const Pumps_List = (t: any) => [
  {
    Header: t("Farm Code"),
    accessor: "farm_code",
  },
  {
    Header: t("Field Code"),
    accessor: "field_code",
  },
  {
    Header: t("PumpCode"),
    accessor: "item_code",
  },
  {
    Header: t("Flow_Rate"),
    accessor: "attributes_value.flow_rate_m3_per_h",
  },
  {
    Header: t("SupplierName"),
    accessor: "supplier_name",
  },
  {
    Header: t("Installation Date"),
    accessor: "installation_date",
  },
];
